import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models';
import { BaseService } from './Base.service';
import { PendingUserDto, SelfRegisterDto } from '../models/registration';

@Injectable({ providedIn: 'root' })
export class RegistrationService extends BaseService<any> {
  private regApiUrl = `${environment.apiUrl}/Auth`;
  private approvalApiUrl = `${environment.apiUrl}/UserApproval`;

  constructor(http: HttpClient) {
    super(http);
    this.apiUrl = `${environment.apiUrl}/Auth`;
  }

  /** Public endpoint — sends X-Tenant-ID but no auth token */
  selfRegister(dto: SelfRegisterDto): Observable<ApiResponse<boolean>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': dto.tenantId,
    });
    return this.http.post<ApiResponse<boolean>>(
      `${this.regApiUrl}/SelfRegister`,
      dto,
      { headers }
    );
  }

  /** Public: (re)send the verification code for a self-registered account */
  sendVerificationCode(email: string): Observable<ApiResponse<boolean>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': localStorage.getItem('tenantId') || '',
    });
    return this.http.post<ApiResponse<boolean>>(
      `${this.regApiUrl}/SendVerificationCode`, { email }, { headers });
  }

  /** Public: verify the code received by email/WhatsApp */
  verifyCode(email: string, code: string): Observable<ApiResponse<boolean>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': localStorage.getItem('tenantId') || '',
    });
    return this.http.post<ApiResponse<boolean>>(
      `${this.regApiUrl}/VerifyCode`, { email, code }, { headers });
  }

  /** Admin: get list of pending users */
  getPendingUsers(): Observable<ApiResponse<PendingUserDto[]>> {
    return this.http.get<ApiResponse<PendingUserDto[]>>(
      `${this.approvalApiUrl}/GetPendingUsers`,
      { headers: this.getHeaders() }
    );
  }

  /** Admin: approve a pending user */
  approveUser(userId: string): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(
      `${this.approvalApiUrl}/ApproveUser/${userId}`,
      {},
      { headers: this.getHeaders() }
    );
  }

  /** Admin: reject (delete) a pending user */
  rejectUser(userId: string): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(
      `${this.approvalApiUrl}/RejectUser/${userId}`,
      { headers: this.getHeaders() }
    );
  }
}
